export var AvatarGroupSize;
(function (AvatarGroupSize) {
    AvatarGroupSize["xLarge"] = "xLarge";
    AvatarGroupSize["large"] = "large";
    AvatarGroupSize["medium"] = "medium";
    AvatarGroupSize["small"] = "small";
    AvatarGroupSize["xSmall"] = "xSmall";
    AvatarGroupSize["xxSmall"] = "xxSmall";
})(AvatarGroupSize || (AvatarGroupSize = {}));
//# sourceMappingURL=types.js.map